/**
 * The sector ↔ game bridge (BUILDLIST 56.4): a page opened with `?sectorBattle`
 * tells its opener it is ready, receives one battle (a MatchSetup with the live
 * planets, and which team the human takes), plays it with Game.startFromSetup,
 * and at game over posts the final state back. The sector sheet (and later the
 * sector screen) turns that state into a BattleOutcome and continues its turn.
 *
 * Both tabs must be the same engine for watch to equal auto-resolve (51.9b's
 * cross-engine float note); the sheet's worker and this page are.
 */
import type { GameState } from '../types';
import type { MatchSetup } from '../match/setup';
import { isSectorBattleRequest, type SectorBattleDone, type SectorBattleReady } from '../sector/battle';

const params = typeof location !== 'undefined' ? new URLSearchParams(location.search) : null;
export const SECTOR_BATTLE = !!params?.has('sectorBattle');

let activeBattleId: string | null = null;

/** With `?sectorBattle`: listen for the battle and start it; tell the opener we are ready. */
export function listenForSectorBattle(start: (setup: MatchSetup, humanTeam: number | null) => void): void {
  if (!SECTOR_BATTLE || typeof window === 'undefined' || !window.opener) return;
  window.addEventListener('message', (e: MessageEvent) => {
    const m = e.data;
    if (!isSectorBattleRequest(m) || activeBattleId) return;
    activeBattleId = m.battleId;
    start(m.setup as MatchSetup, m.humanTeam);
  });
  const ready: SectorBattleReady = { type: 'orbituary:sectorBattleReady' };
  (window.opener as Window).postMessage(ready, '*');
}

/** At game over: hand the final state back to the opener (no-op outside a sector battle). */
export function postSectorBattleDone(state: GameState): void {
  if (!activeBattleId || typeof window === 'undefined' || !window.opener) return;
  const done: SectorBattleDone = { type: 'orbituary:sectorBattleDone', battleId: activeBattleId, state };
  try { (window.opener as Window).postMessage(done, '*'); } catch (err) { console.warn('sector battle: could not post the final state', err); }
  activeBattleId = null;
}
